import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'formio-skeleton',
  template: `<div
    [ngClass]="containerClass()"
    [class]="styleClass"
    [ngStyle]="containerStyle()"></div>`,

  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FormIOSkeletonComponent {
  @Input() styleClass: string;

  @Input() style: any;

  @Input() shape: string = 'rectangle';

  @Input() animation: string = 'wave';

  @Input() radius: string = null;

  @Input() size: string = null;

  @Input() width: string = '100%';

  @Input() height: string = '1rem';

  containerClass() {
    return {
      'skeleton component': true,
      'skeleton-circle': this.shape === 'circle',
      'skeleton-none': this.animation === 'none',
      'skeleton-opacity': this.animation === 'opacity',
    };
  }

  containerStyle() {
    if (this.size)
      return {
        ...this.style,
        width: this.size,
        height: this.size,
        borderRadius: this.radius,
      };
    else
      return {
        ...this.style,
        width: this.width,
        height: this.height,
        borderRadius: this.radius,
      };
  }
}
